export default "__VITE_ASSET__957ba885__"